import { type ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/** An empty screen is an invitation to act — never just "no data". */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 rounded-card bg-card px-6 py-14 text-center', className)}>
      {icon && <span className="inline-flex size-12 items-center justify-center rounded-card bg-surface text-muted">{icon}</span>}
      <div className="max-w-sm">
        <p className="font-display text-lg font-semibold text-ink">{title}</p>
        {description && <p className="mt-1 text-sm text-muted">{description}</p>}
      </div>
      {action}
    </div>
  );
}

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-control bg-line/70', className)} />;
}
